import { render } from "./EmergencyModal.vue?vue&type=template&id=5c67b341&ts=true"
import script from "./EmergencyModal.vue?vue&type=script&lang=ts"
export * from "./EmergencyModal.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__